__webpack_require__.p = "https://static.msscdn.net/static/codi/0.1.0/";